import Vue from "vue";
// istenilen element dışında basıldığında tetiklenen func.
Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      const path =
        typeof event.composedPath === "function" ? event.composedPath() : null;
      const isInside = path
        ? path.includes(el)
        : el === event.target || el.contains(event.target);

      if (!isInside) {
        const handler =
          typeof binding.value === "function"
            ? binding.value
            : binding.expression && vnode.context[binding.expression];
        if (typeof handler === "function") handler(event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  },
});
